import __request__ from "routing/request";
export function get(string, flatten = false, list_separator, key_separator, replace_key_whitespace, key_whitespace_replacement, key_prefix, kv_separator, requestOptions) {
  return __request__("GET", "/tools/json_tester", null, { "string": string, "flatten": flatten, "list_separator": list_separator, "key_separator": key_separator, "replace_key_whitespace": replace_key_whitespace, "key_whitespace_replacement": key_whitespace_replacement, "key_prefix": key_prefix, "kv_separator": kv_separator }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function post(JSONbody, requestOptions) {
  return __request__("POST", "/tools/json_tester", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
